import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil", testid: "nav-link-home" },
  { to: "/services", label: "Services", testid: "nav-link-services" },
  { to: "/qui-sommes-nous", label: "Qui sommes-nous ?", testid: "nav-link-who" },
  { to: "/fiches-cee", label: "Fiche CEE", testid: "nav-link-fiches" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `text-sm tracking-wide transition-colors duration-300 ${
      isActive ? "text-gold-bright" : "text-slate-300 hover:text-gold"
    }`;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-navy-950/85 border-b border-gold/20">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 sm:px-10 py-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img
            src="/logo.png"
            alt="Levi One — Conseil, Étude, Accompagnement"
            className="h-11 w-11 rounded-full ring-1 ring-gold/40 transition-transform duration-500 group-hover:rotate-6"
          />
          <div className="leading-tight">
            <span className="block text-white font-semibold tracking-[0.2em] text-sm">
              LEVI <span className="text-gold">ONE</span>
            </span>
            <span className="block text-[10px] tracking-[0.28em] text-slate-400">
              CONSEIL • ÉTUDE • ACCOMPAGNEMENT
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={l.testid} className={linkClass} end={l.to === "/"}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="header-cta-button"
            className="bg-gradient-to-r from-gold to-gold-bright hover:from-gold-bright hover:to-gold text-navy-950 font-semibold text-sm px-5 py-2.5 rounded-full shadow-lg shadow-gold/20 transition-all duration-300 hover:-translate-y-0.5"
          >
            Demander une étude
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-200 hover:text-gold transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="md:hidden border-t border-gold/10 bg-navy-950/95 px-6 py-4 flex flex-col gap-4" data-testid="mobile-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-${l.testid}`}
              className={linkClass}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="mobile-header-cta-button"
            onClick={() => setOpen(false)}
            className="bg-gradient-to-r from-gold to-gold-bright text-navy-950 font-semibold text-sm px-5 py-2.5 rounded-full text-center"
          >
            Demander une étude
          </Link>
        </nav>
      )}
    </header>
  );
};
